var classes = {"colorSwatchWrapper":"DyIx-","selected":"Jg7Fq","disabled":"Kobtb","colorSwatch":"x1a-4","square":"_0rhok","rectangle":"rk3E-","colorSwatchColor":"_4Aov8","small":"EYjAD","large":"vdJO6"};

export { classes as default };
